// Extract unique departments for filter
export const extractFilterValues = (data) => {
  const departments = [...new Set(data.map((discharge) => discharge.department))].sort()

  return {
    departments,
    statuses: ['Completed', 'Pending']
  }
}

// Apply filters to discharge data
export const applyFilters = (data, filters) => {
  const { searchText, departmentFilter, statusFilter, dateRange } = filters

  return data.filter((discharge) => {
    // Text search
    const textMatch =
      searchText === '' ||
      discharge.patientName.toLowerCase().includes(searchText.toLowerCase()) ||
      discharge.patientId.toLowerCase().includes(searchText.toLowerCase()) ||
      discharge.dischargeId.toLowerCase().includes(searchText.toLowerCase()) ||
      (discharge.diagnosisList &&
        discharge.diagnosisList.some((diagnosis) => diagnosis.toLowerCase().includes(searchText.toLowerCase())))

    // Department filter
    const departmentMatch = departmentFilter === 'all' || discharge.department === departmentFilter

    // Status filter
    const statusMatch = statusFilter === 'all' || discharge.status === statusFilter

    // Date range filter
    let dateMatch = true
    if (dateRange && dateRange[0] && dateRange[1]) {
      const dischargeDate = new Date(discharge.dischargeDate)
      const startDate = dateRange[0].startOf('day').toDate()
      const endDate = dateRange[1].endOf('day').toDate()
      dateMatch = dischargeDate >= startDate && dischargeDate <= endDate
    }

    return textMatch && departmentMatch && statusMatch && dateMatch
  })
}

// Split filtered data by status
export const splitByStatus = (filteredData) => {
  const completedDischarges = filteredData.filter((discharge) => discharge.status === 'Completed')
  const pendingDischarges = filteredData.filter((discharge) => discharge.status === 'Pending')

  return {
    completedDischarges,
    pendingDischarges
  }
}
